<template>
    <div>
        部屋利用状況確認
    </div>
</template>
      
<script>
export default {};
</script>
      
<style>
</style>
      